"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = void 0;
var DeviceType;
(function (DeviceType) {
    DeviceType["Phone"] = "phone";
    DeviceType["Tablet"] = "tablet";
    DeviceType["TV"] = "tv";
    DeviceType["Desktop"] = "desktop";
    DeviceType["Unknown"] = "unknown";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
